/* istanbul ignore next -- @preserve */
export const encodeHtml = (input: string) =>
  input.replace(/[\u00A0-\u9999<>&]/g, (i) => '&#' + i.charCodeAt(0) + ';');
